<template>
    <a href="/flow" class="block mb-8 text-highlight-100" @click.stop.prevent="route">
        <span class="chevron-left"></span>
        {{ _('navigation_back') }}
    </a>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    props: {
        location: String,
    },
    computed: {
        ...mapGetters({
            _: 'localisation/translate',
        }),
    },
    methods: {
        route() {
            this.$router.push({ name: this.location })
        },
    },
}
</script>
<style scoped>
    .chevron-left {
        @apply inline-block border-highlight-100 border-solid transform rotate-45;
        width: 0.6rem;
        height: 0.6rem;
        border-width: 0 0 2px 2px;
    }
</style>
